import { render, staticRenderFns } from "./ContributionsGraphWidget.vue?vue&type=template&id=1418b666&scoped=true"
import script from "./ContributionsGraphWidget.vue?vue&type=script&lang=ts"
export * from "./ContributionsGraphWidget.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsGraphWidget.vue?vue&type=style&index=0&id=1418b666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418b666",
  null
  
)

export default component.exports